import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckboxChecked = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: 1,
		y: 1,
		width: 18,
		height: 18,
		rx: 5,
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M5.26758 10.6761L7.97158 13.3801L14.7316 6.62012",
		stroke: "white",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgCheckboxChecked;
